import { computed, Injectable, signal } from '@angular/core';

export type SidebarMode =
  | 'mobile'
  | 'mini-expanded'
  | 'mini-collapsed'
  | 'full';
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  #mode = signal<SidebarMode>('mobile');
  #isHidden = signal(false);

  mode = this.#mode.asReadonly();
  isHidden = this.#isHidden.asReadonly();

  isFull = computed(() => this.#mode() === 'full');
  isMobile = computed(() => this.#mode() === 'mobile');
  isMiniExpanded = computed(() => this.#mode() === 'mini-expanded');
  isMiniCollapsed = computed(() => this.#mode() === 'mini-collapsed');
  isMini = computed(
    () => this.#mode() === 'mini-expanded' || this.#mode() === 'mini-collapsed',
  );
  isExpanded = computed(
    () =>
      this.#mode() === 'mobile' ||
      this.#mode() === 'mini-expanded' ||
      this.#mode() === 'full'
  );

  setMode(mode: SidebarMode): void {
    this.#mode.set(mode);
  }

  setVisibility(isVisible: boolean): void {
    this.#isHidden.set(!isVisible);
  }
}
